import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { ReactComponent as CrossIcon } from '@sketch/icons/cross-circle-18-svg'
import { ReactComponent as ExclamationMark } from '@sketch/icons/exclamation-mark-16-svg'
import { ReactComponent as Information } from '@sketch/icons/information-16-svg'

import {
  Wrapper,
  BannerType,
  CloseButton,
  Text,
  IconWrapper,
} from './Banner.styles'

export interface BannerProps {
  className?: string
  type: BannerType
  dismissible?: boolean
  onDismiss?: (event: React.MouseEvent<HTMLElement>) => void
  showIcon?: boolean
}

const Banner: React.FC<BannerProps> = props => {
  const {
    className,
    children,
    type,
    dismissible,
    onDismiss,
    showIcon = true,
  } = props

  // Return the custom component and inject a data-testid for testing
  if (type === 'custom') {
    const items = React.Children.toArray(children)

    return (
      <>
        {items.map(item => {
          return React.cloneElement(item as ReactElement, {
            'data-testid': `banner-${type}`,
          })
        })}
      </>
    )
  }

  const Icon = type === 'error' ? ExclamationMark : Information

  return (
    <Wrapper
      className={className}
      data-testid={`banner-${type}`}
      role="alert"
      $type={type}
    >
      {showIcon && (
        <IconWrapper>
          <Icon />
        </IconWrapper>
      )}
      <Text>{children}</Text>
      {dismissible && (
        <CloseButton onClick={onDismiss}>
          <span className="sr-only">Close banner</span>
          <CrossIcon aria-hidden />
        </CloseButton>
      )}
    </Wrapper>
  )
}
export default styled(Banner)``
